import * as Sentry from '@sentry/react';

export default class LoggerApi {
  public async fetch(...args: unknown[]): Promise<Response | void> {
    const body = JSON.stringify({ ...args });
    const method = 'POST';

    const headers = new Headers();

    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');

    return fetch(`${import.meta.env.VITE_LOGGING_URL}`, {
      method,
      body,
      headers,
    }).catch((error) => {
      Sentry.captureException(error, {
        extra: {
          url: import.meta.env.VITE_LOGGING_URL,
          method,
          body,
        },
      });
    });
  }
}
